// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.overbooked[data-v-512cc6c4] {\n  color: red;\n  font-weight: 500;\n}\n.expanded-row[data-v-512cc6c4] {\n  padding: 0 !important;\n}\n.event-info[data-v-512cc6c4] {\n  display: flex;\n  flex-direction: column;\n}\n.event-info--caption[data-v-512cc6c4] {\n  font-size: 0.75em;\n}\n.spacer-cell[data-v-512cc6c4] {\n  width: 0;\n}\n", ""]);
// Exports
module.exports = exports;
